export enum SocialMethodEnum {
    VK = 'GetVkUserInfo',
    Google = 'GetGgUserInfo',
    Facebook = 'GetFbUserInfo',
    OK = 'GetOkUserInfo'
}



// WEBPACK FOOTER //
// ./src/app/shared/dictionaries/SocialMethodEnum.ts